var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckBoxEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 2.5H3.75C3.05859 2.5 2.5 3.05859 2.5 3.75V16.25C2.5 16.9414 3.05859 17.5 3.75 17.5H16.25C16.9414 17.5 17.5 16.9414 17.5 16.25V3.75C17.5 3.05859 16.9414 2.5 16.25 2.5ZM15.873 15.5208C15.873 15.6927 15.7324 15.8333 15.5605 15.8333H4.47917C4.30729 15.8333 4.16667 15.6927 4.16667 15.5208V4.42708C4.16667 4.25521 4.30729 4.11458 4.47917 4.11458H15.5605C15.7324 4.11458 15.873 4.25521 15.873 4.42708V15.5208Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxEmpty);
export default __webpack_public_path__ + "static/media/CheckBoxEmpty.e4c0476e.svg";
export { ForwardRef as ReactComponent };